import React, {useCallback, useEffect} from 'react';
import {Box, Typography, Button} from '@mui/material';
import KeycloakInstance from '@/services/keycloak';
import {useTranslation} from 'react-i18next';
import {useSnackbar} from '@/contexts/snackbar';

const RequireAuthenticationPage = () => {
  const {t} = useTranslation();

  const {showSnackbarMessage} = useSnackbar();

  const handleLogin = useCallback(() => {
    KeycloakInstance.onErrorCallback = (error) => {
      if (error.message === 'Insufficient rights') {
        showSnackbarMessage(t('error_no_loginpermission'), 'error', 20000);
      }
    };
    if (!KeycloakInstance.authenticated) {
      KeycloakInstance.loginExternal().catch((error) => {
        console.error('Login failed: ', error);
      });
    } else {
      console.info('Already logged in');
    }
  }, [showSnackbarMessage, t]);

  useEffect(() => {
    const timer = setTimeout(handleLogin, 3000);
    return () => clearTimeout(timer);
  }, [handleLogin]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      textAlign="center"
    >
      <Typography variant="h1" component="div" gutterBottom></Typography>
      <Typography variant="h5" component="div" gutterBottom>
        {t('user_not_authenticated')}
      </Typography>
      <Typography variant="body1" component="div" gutterBottom marginTop={2}>
        {t('authentication_required')}
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={handleLogin}
        sx={{
          marginTop: 3
        }}
      >
        {t('direct_to_login')}
      </Button>
    </Box>
  );
};

export default RequireAuthenticationPage;
